import React from 'react';
import { motion } from 'framer-motion';
interface AnimatedCheckProps {
  delay?: number;
}
export function AnimatedCheck({
  delay = 0
}: AnimatedCheckProps) {
  return <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" style={{
    flexShrink: 0
  }} data-id="element-35" data-mp="1u2df7ut5pr9b">
      <circle cx="12" cy="12" r="11" stroke="rgba(196,18,48,0.35)" strokeWidth="1.5" data-id="element-36" data-mp="1l28c3wuzxf0y" />
      <motion.path d="M7 12.5l3.2 3.2L17 9" stroke="#C41230" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" initial={{
      pathLength: 0,
      opacity: 0
    }} whileInView={{
      pathLength: 1,
      opacity: 1
    }} viewport={{
      once: true,
      amount: 0.6
    }} transition={{
      duration: 0.55,
      delay,
      ease: 'easeInOut'
    }} data-id="element-37" data-mp="16dlxjxd70ras" />
    </svg>;
}